import { useCallback } from 'react';
import ajax from '../utils/ajaxHelper';

/*
  Created By: Faisal Khan
  Date:2022-03-08
  Description: save Learning Opportunity 
*/
const useLearningOpportunity = () => {
  const saveLearningOpportunity = useCallback(async (payload) => {
    try {
      return await ajax.post('learning-opportunity/save', payload, {
        networkParams: { showLoader: false },
      });
    } catch (error) {
      console.log(error);
    }
  });
  const learningOpportunityList = useCallback(async () => {
    try {
      return await ajax.get(
        'learning-opportunity/list',
        /* payload, */ {
          networkParams: { showLoader: false },
        },
      );
    } catch (error) {
      console.log(error);
    }
  });
  const learningOpportunityOptions = useCallback(async () => {
    try {
      return await ajax.get(
        'learning-opportunity/options',
        /* payload, */ {
          networkParams: { showLoader: false },
        },
      );
    } catch (error) {
      console.log(error);
    }
  });
  const deleteLearningOpportunity = useCallback(async (payload) => {
    try {
      return await ajax.post('learning-opportunity/delete', payload, {
        networkParams: { showLoader: false },
      });
    } catch (error) {
      console.log(error);
    }
  });
  return {
    saveLearningOpportunity,
    learningOpportunityList,
    deleteLearningOpportunity,
    learningOpportunityOptions,
  };
};
export default useLearningOpportunity;
